module.exports = __webpack_public_path__ + "img/poznan.77c6aede.jpg";